import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DocumentosProjeto } from '../models/documentos-projeto.model';
import { DocumentosProjetoService } from '../services/documentos-projeto.service';


@Component({
  selector: 'app-pf-tutorial-edit',
  templateUrl: './pf-tutorial-edit.component.html',
  styleUrls: ['./pf-tutorial-edit.component.scss']
})
export class PfTutorialEditComponent extends BaseFormComponent<DocumentosProjeto> implements OnInit {

  type: boolean;

  constructor(
    private myService: DocumentosProjetoService,
    public activatedRoute: ActivatedRoute,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.loaded();
  }

}
